// We include ?simple if we are in simple mode because cornerstone gets upset if we use the same loaded image
//  for 2D and 3D.
const getWadoImageId = (type, uid, index, simple = false) => {
  const imageRootUrl = '/weekly-check/api/{organization}/dicom';

  return `rad-streaming-wadors:${imageRootUrl}/${type}/${uid}-${index}${simple ? '?simple' : ''}`;
};

export default getWadoImageId;